import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { NgModule, NgZone } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { BaseComponent, FunctionalToolbarItemComponent } from "@indusoft/angular-base";
import { AuthenticationService } from '@indusoft/authenticator';
import { TooltipDirective } from "@indusoft/tooltip";
import { OverlayWindowService, OverlayWindowSettings } from "@indusoft/overlay-window";

import { HeaderComponent } from './header.component';
import { AuthHttpService } from "../../auth/app/services/auth/auth-http.service";
import { ConfigurationHttpService } from "../../common/services/configuration.service";
import { AasAuthenticatorModule } from '../../aas-authentificator/app/aas-authentificator.module';
import { BaseRouteInterceptor } from '../../common/core/base-route.interceptor';
import { LcInterceptor } from '../../common/services/lc-interceptor';
import { LicenseHttpService } from "../../common/services/license-http-service";
import { IndusoftUIInteractionService } from '../../common/services/indusoft-ui-interaction-service';
import { LocalStorageService } from '@indusoft/angular-base-services';

@NgModule({
    declarations: [HeaderComponent],
    imports: [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        BaseComponent,
        FunctionalToolbarItemComponent,
        AasAuthenticatorModule,
        TooltipDirective
    ],
    providers: [
        {
            provide: APP_BASE_HREF,
            useFactory: getBaseHref,
            deps: [PlatformLocation]
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BaseRouteInterceptor,
            multi: true
        },
        IndusoftUIInteractionService,
        LocalStorageService,
        OverlayWindowService,
        OverlayWindowSettings,
        AuthHttpService,
        ConfigurationHttpService,
        AuthenticationService,
        LcInterceptor,
        LicenseHttpService
    ],
    bootstrap: [HeaderComponent]
})

export class HeaderModule {
    constructor(private ngZone: NgZone) {
        (window as any).ngZone = this.ngZone;
    }
}

export function getBaseHref(platformLocation: PlatformLocation): string {
    return platformLocation.getBaseHrefFromDOM();
}
